import { MDBRow} from "mdbreact";
import React from "react";
import IconCheck from "../../../../new_images/Landing/Icons/Icon_visto.png";
import "./Recomendaciones.css"


class Disfruta extends React.Component {
  render() {
    return (
      <section className="text-left my-5">
        <div style={{display:"flex", justifyContent:"center"}}>
          <div className=" col-lg-6 col-sm-8 view-recomendacionp" style={{display:"grid"}}>
            <p
              className="ph_titulo " style={{margin:"5px"}}
            >
              Recomendaciones para pasajeros
            </p>
          </div>
        </div>

      <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "10px"
                }}>
        <div>
          <MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1 col-md-1 col-sm-1">
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-2" >
                <p className="ph_texto">Revisa siempre los datos que te proporcionamos y verifica la identidad del conductor asignado.</p>
              </div>
            </MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ph_texto">Evita distraer al conductor, y asegurate que cumpla con todos las medidas adecuadas de bio-seguridad.</p>
              </div>
            </MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ph_texto">Mantén limpio el interior del auto y evita causar cualquier daño al vehículo. Demostrar respeto es necesario para un ambiente sano.</p>
              </div>
            </MDBRow>
            <MDBRow center style={{width:"100%"}}>
              <div className="col-lg-1" >
                <div className="img_num">
                <img src={IconCheck} height="30px" alt="servicio de calidad" style={{marginTop: "10px", marginBottom: "10px"}} /> 
              </div>
              </div>
              <div className="col-lg-6" >
                <p className="ph_texto">Califica al conductor para ayudar a conocer la calidad del viaje a otros pasajeros, y sé libre de sugerir como mejorar la experiencia de viaje.</p>
              </div>
            </MDBRow>
          </MDBRow>   
        </div>
      </div>
    </section>
    );
  }
}

export default Disfruta;
